import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IBuilding, TaskApiService } from 'shared';

import { AppStateService } from './state';

@Injectable({ providedIn: 'root' })
export class BuildingService {
    private appState = inject(AppStateService);
    private readonly taskApi = inject(TaskApiService);

    private readonly _buildings: BehaviorSubject<Array<IBuilding>> = new BehaviorSubject<Array<IBuilding>>([]);
    public readonly buildings: Observable<Array<IBuilding>> = this._buildings.asObservable();

    public constructor() {
        this.appState.user.distinctStream
            .pipe(
                switchMap(async (user) => {
                    if (user) {
                        // Refresh data on login
                        await this.refreshBuildings();
                    } else {
                        // Clear data on logout
                        this._buildings.next([]);
                    }
                })
            )
            .subscribe();
    }

    public async refreshBuildings(): Promise<Array<IBuilding>> {
        const buildings = await firstValueFrom(this.taskApi.getBuildings());
        this._buildings.next(buildings);
        return buildings;
    }

    public getBuildingForIdSync(id: string): IBuilding | null {
        return this._buildings.value.find((building) => building.id === id) ?? null;
    }
}
